module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/hooks-lore-hook-reducers.json
// module id = 2230
// module chunks = 26708780685369